import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IEndedListingPatient } from "../../../models/IEndedListingPatient"
import { Link } from 'react-router-dom';
import { PATIENT } from '../../../utils/RouteConstants';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { formatDate } from "../../../helpers/DateHelper"

interface IPatientUnlistedTable {
    id: string | undefined;
    data: IEndedListingPatient[] | undefined;
}

export const ListingsEndedTable: React.FunctionComponent<IPatientUnlistedTable> = ({ id, data }) => {


    const goToPatientLink = (text: string, patientGuidId: string) => {
        return (
            <Link to={`/${PATIENT}/${patientGuidId}`}>{text}</Link>
        )
    }

    return (
        <section id={id} className="patient-unlisted-table">
            {
                data
                    ? <Table hoverableRows={data.length > 0}>
                        <thead>
                            <tr>
                                <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                                <SortableTableHeader propertyToSortBy="Patient.FirstName" headerText="Namn" />
                                <SortableTableHeader propertyToSortBy="Patient.Address.AddressRow" headerText="Adress" />
                                <SortableTableHeader propertyToSortBy="Patient.Address.CityCode" headerText="Postnummer" />
                                <SortableTableHeader propertyToSortBy="Patient.Address.City" headerText="Postadress" />
                                <SortableTableHeader propertyToSortBy="ListingEndedDate" headerText="Datum för avlistning" />
                                <SortableTableHeader propertyToSortBy="ListingStatus.Description" headerText="Orsak" />
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.length > 0
                                    ? data.map((patient, key) => {
                                        return (
                                            <tr className="clickable-row align-text-bottom" key={key} >
                                                <td className="table-data-link">{goToPatientLink(formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityNumber), patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.name, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.address, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.zipCode, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.city, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(formatDate(patient.dateOfUnlisting), patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.listingEndedStatus, patient.patientGuidId)}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td colSpan={8}>Det finns inga avlistade patienter att visa</td></tr>
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </section>
    )
}